import { Route } from '@angular/router';
import { CanDeactivateGuard } from '@pkp-g/core';

export const whitelistsRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full',
  },
  {
    path: 'list',
    loadComponent: () => import('./pages').then(p => p.WhitelistListPage),
    title: 'UIMS - Whitelists',
  },
  {
    path: 'create',
    loadComponent: () => import('./pages').then(p => p.WhitelistCreateComponent),
    title: 'UIMS - Whitelists',
  },
  {
    path: 'details/:id',
    loadComponent: () => import('./pages').then(p => p.WhitelistDetailsComponent),
    title: 'UIMS - Whitelist Details',
    canDeactivate: [CanDeactivateGuard],
  },
];
